import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingDisplayProps {
  message?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showSpinner?: boolean;
}

export default function LoadingDisplay({ 
  message = 'Loading...', 
  className = '', 
  size = 'md',
  showSpinner = true 
}: LoadingDisplayProps) {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const spinnerSizes = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6'
  };

  return (
    <div className={`flex items-center justify-center space-x-2 text-text-secondary ${sizeClasses[size]} ${className}`}>
      {showSpinner && (
        <Loader2 className={`animate-spin ${spinnerSizes[size]}`} />
      )}
      <span>{message}</span>
    </div>
  );
}